export const API_PREFIX_V2 = 'apiv2_';

export type ACTION_RESPONSE =
  | 'pong'
  | 'subscriptions'
  | `${typeof API_PREFIX_V2}priceStream`
  | `${typeof API_PREFIX_V2}pricing`
  | `${typeof API_PREFIX_V2}dcdGrid`
  | `${typeof API_PREFIX_V2}eventsReport`
  | `${typeof API_PREFIX_V2}riskReport`
  | `${typeof API_PREFIX_V2}pnlReport`
  | `${typeof API_PREFIX_V2}cashFlowsReport`
  | `${typeof API_PREFIX_V2}lifeCycling`
  | `${typeof API_PREFIX_V2}createAndSaveTradesFromAllocationParameters`
  | `${typeof API_PREFIX_V2}rfqMessage`
  | `${typeof API_PREFIX_V2}rfqHedgeQuote`
  | `${typeof API_PREFIX_V2}ratesLadder`
  | `clientPrice`
  | 'strategies'
  | 'tradeNotification'
  | 'marketData'
  | 'notification';

type ACTION_REQUEST =
  | `ping`
  | `subscribe`
  | `unsubscribe`
  | `priceStream`
  | `dcdGrid`
  | `pricing`;

export type ACTION =
  | ACTION_RESPONSE
  | `${typeof API_PREFIX_V2}${ACTION_REQUEST}`;

export type BaseMessage<T> = {
  action: ACTION;
  payload?: T;
  uuid?: string; // will be generated if not provided
};

export type ClientMessage<T> = BaseMessage<T> & {
  identity?: { jwtToken: string };
};

export type ServerMessage<T> = BaseMessage<T> & {
  channel?: string;
  body?: T; // backwards compatibility
  error?: { status: string; message: string } & Record<string, any>;
};

export type SocketOptions = {
  action?: ACTION; // filter by action
  uuid?: string; // filter by this uuid
  take?: number; // Needs UUID.  Default 1, use a large no., e.g. Infinity, for all messages
};

export type PongResponse = {
  timeIn: number;
  timeOut: number;
};

export type SubscriptionsResponsePayload = {
  channels: string[];
};

export type SubscribeRequestPayload = SubscriptionsResponsePayload;

export type UnsubscribeRequestPayload = {
  uuid: string;
};
